import { gql } from "gql";

export const GET_COMPANY_DOCUMENT_FOLDER_BY_ID = gql(/* GraphQL */ `
  query GetCompanyDocumentFolderById($id: ID!) {
    getCompanyDocumentFolderById(id: $id) {
      id
      parentId
      name {
        ...LocalizedValueDtoFragment
      }

      ...CompanyDocumentFolderColor

      access {
        organizations {
          id
        }
        positions {
          id
        }
        jobs {
          id
        }
      }
    }
  }
`);
